var map = {
	"./bg copy.jpg": 86,
	"./bg-1.jpg": 1487,
	"./bg-2.jpg": 4112,
	"./bg-final.jpg": 8082,
	"./bg.png": 2541,
	"./card-bg.png": 2636,
	"./desktop-bg.png": 8584,
	"./gitex/bg.jpeg": 4148,
	"./gitex/lector.png": 7141,
	"./lectors/-avatar-3.png": 875,
	"./lectors/avatar-2.png": 1843,
	"./lectors/avatar-3.png": 6634,
	"./lectors/avatar.png": 1402,
	"./next-speaker.jpeg": 6372,
	"./qr.jpg": 7753,
	"./stand-bg-2-old.jpg": 8721,
	"./stand-bg-2.jpg": 6173,
	"./stand-bg-old.jpg": 6164,
	"./stand-bg.jpg": 3084,
	"./stand-bg.png": 5176,
	"./stream-bg.png": 8702,
	"./summary.jpg": 3762,
	"./voice-time-line.png": 9313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4610;